import React, { type PropsWithChildren, useEffect } from "react";

import { useAxiosClient } from "igfd-commons/src/http";

/**
 * Declares the minimum role required by inventory-app requests so the gateway
 * lets through users who only hold INVENTORY_MANAGER (not full MANAGER).
 *
 * Mounted by the AuthenticatedLayout alongside AxiosAuthTokenProvider.
 */
export const AxiosInventoryRoleProvider = ({ children }: PropsWithChildren) => {
  const clientWithAuth = useAxiosClient({ withAuth: true });

  useEffect(() => {
    const interceptorId = clientWithAuth.interceptors.request.use((config) => {
      config.headers["x-role"] = "INVENTORY_MANAGER";
      return config;
    });
    return () => {
      clientWithAuth.interceptors.request.eject(interceptorId);
    };
  }, [clientWithAuth]);

  return <>{children}</>;
};
